import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import "../VehiculeForm.css";
import api from '../../../api/config'

const StepTwoOccasion = ({ sendData, isActive, onNext, onPrevious, commonData, handleSave }) => {
    const [sellerType, setSellerType] = useState(null); // null, 'physique', or 'morale'
    const [buyerType, setBuyerType] = useState(null); // null, 'physique', or 'morale'

    const [formData, setFormData] = useState({
        // ANCIEN PROPRIETAIRE - CONCESSION (en cas de cession)
        occ_app_1: null, // "Vous êtes :" 0: personne physique 1: personne morale
        // si personne physique
        occ_app_2: null, // "Sexe" 0: homme 1: femme
        occ_app_3: null, // "Nom et prénom"
        // si personne morale
        occ_app_4: null, // "Raison sociale :"
        occ_app_5: null, // "N° SIRET :"
        occ_app_5_2: null, // "N° SIREN :"

        occ_app_6: null, // "N° de la voie :"
        occ_app_7: null, // "Complément (bis, ter,..) :"
        occ_app_8: null, // "Type de voie (rue, avenue..) :"
        occ_app_9: null, // "Nom de la voie :"
        occ_app_10: null, // "Code postal :"
        occ_app_11: null, // "Commune "
        occ_app_12: null, // "Je certifie :" 0: Ceder 1: Céder pour destruction
        occ_app_13_1: null, // "Le :" JJ 
        occ_app_13_2: null, // "Le :" MM
        occ_app_13_3: null, // "Le :" AAAA
        occ_app_14_1: null, // "A" HH
        occ_app_14_2: null, // "A" MM

        // "Je certifie en outre (veuillez cocher la ou les case.s correspondante.s) :"
        occ_app_15: '0', // checkbox 1 "Avoir remis au nouveau propriétaire un certificat établi depuis moins de quinze jours..."
        occ_app_16: '0', // checkbox 2 "Que ce véhicule n'a pas subi de transformation notable..."
        occ_app_17: '0', // checkbox 3 "Que ce véhicule est cédé pour destruction à un professionnel de la destruction..."

        // TITULAIRE - NOUVEAU PROPRIETAIRE
        occ_tit_1: null, //  "Vous êtes :" 0: personne physique 1: personne morale
        // si personne physique
        occ_tit_2: null, // // "Sexe" 0: homme 1: femme
        occ_tit_3: null, // "Nom et prénom"
        occ_tit_4: null, // "Nom d'usage (facultatif) :"
        occ_tit_5_1: null, // "Date de naissance :" JJ
        occ_tit_5_2: null, // "Date de naissance :" MM
        occ_tit_5_3: null, // "Date de naissance :" AAAA
        occ_tit_6: null, // "Commune de naissance :"
        occ_tit_7: null, // "Département de naissance :"
        occ_tit_8: null, //"Pays de naissance :"
        // si personne morale
        occ_tit_9: null, // "Raison sociale :"
        occ_tit_10: null, // "N° SIRET :"
        occ_tit_11: null, // " "N° SIREN :""

        occ_tit_12: null, // "Etage / Escalier / Appartement :"
        occ_tit_13: null, // "Immeuble / Résidence / Bâtiment :"
        occ_tit_14: null, // "N° de la voie :"
        occ_tit_15: null, // "Extension (bis, ter, ..) : "
        occ_tit_16: null, // "Type de voie (rue, avenue, ..) :"
        occ_tit_17: null, // "Libellé de voie :"
        occ_tit_18: null, // "Lieu-dit / BP / Localité :"
        occ_tit_19: null, // "Code postal :"
        occ_tit_20: null, // "Commune :"
        occ_tit_21: null, // "Téléphone portable :"
        occ_tit_22: null, //  "Adresse mail "

        // "Certifie (veuillez cocher la ou les case.s correspondante.s) :"
        occ_tit_23: '0', // checkbox 1 "Acquérir le véhicule désigné ci-dessus aux dates et heures indiquées..."
        occ_tit_24: '0', // checkbox 2 "Avoir été informé de la situation administrative du véhicule"

        // CO-TITULAIRE (En cas de demande d'immatriculation)
        occ_cotit_0: null, // "Le véhicule est-il dans un cas de multi-propriété ?" 0: pas multipropriete 1: multipropriete
        occ_cotit_1: null, // "Nombre de personnes titulaires du certificat d'immatriculation : "
        occ_cotit_2: null, // "Vous êtes :" 0: personne physique 1: personne morale
        occ_cotit_gender: null, // "Sexe co-titulaire" 0: homme 1: femme
        // si physique
        occ_cotit_3: null, // "Nom et prénom"
        occ_cotit_4: null, // "Nom d'usage (facultatif) :"
        // si moral
        occ_cotit_5: null, // "Raison sociale :"
        occ_cotit_6: null, // "N° SIRET :"
    });

    useEffect(() => {
        if (commonData) {
            if (commonData.stepTwoData && Object.keys(commonData.stepTwoData).length > 0) {
                setFormData(prevState => ({
                    ...prevState,
                    ...commonData.stepTwoData
                }));
                
                // Définir le type de vendeur en fonction des données
                if (commonData.stepTwoData.occ_app_1 !== null && commonData.stepTwoData.occ_app_1 !== undefined) {
                    setSellerType(commonData.stepTwoData.occ_app_1 === '0' ? 'physique' : 'morale');
                } else if (commonData.stepTwoData.occ_app_3) {
                    // Si le nom et prénom sont remplis mais que le type n'est pas défini
                    setSellerType('physique');
                } else if (commonData.stepTwoData.occ_app_4) {
                    // Si la raison sociale est remplie mais que le type n'est pas défini
                    setSellerType('morale');
                }
                
                // Définir le type d'acquéreur en fonction des données
                if (commonData.stepTwoData.occ_tit_1 !== null && commonData.stepTwoData.occ_tit_1 !== undefined) {
                    setBuyerType(commonData.stepTwoData.occ_tit_1 === '0' ? 'physique' : 'morale');
                } else if (commonData.stepTwoData.occ_tit_3) {
                    // Si le nom et prénom sont remplis mais que le type n'est pas défini
                    setBuyerType('physique');
                } else if (commonData.stepTwoData.occ_tit_9) {
                    // Si la raison sociale est remplie mais que le type n'est pas défini
                    setBuyerType('morale');
                }
            } else {
                const { numero_dossier, statut, vendeur_id } = commonData;
                setFormData(prevState => ({
                    ...prevState,
                    numero_dossier,
                    statut,
                    vendeur_id
                }));
            }
        }
    }, [commonData]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        // --- ANCIEN PROPRIÉTAIRE (VENDEUR) ---

        // Saisie "personne morale" -> on force occ_app_1 = 1 ET on nettoie les champs "physique"
        if (['occ_app_4', 'occ_app_5', 'occ_app_5_2'].includes(name)) {
            const cleaned =
                name === 'occ_app_4'
                    ? value.toUpperCase()
                    : value.replace(/[^0-9]/g, '');

            setFormData(prev => ({
                ...prev,
                [name]: cleaned,
                occ_app_1: '1',   // personne morale
                // on vide les champs personne physique
                occ_app_2: null,
                occ_app_3: '',
            }));
            setSellerType('morale');
            return;
        }

        // Saisie "personne physique" -> on force occ_app_1 = 0 ET on nettoie les champs "morale"
        if (name === 'occ_app_3') {
            setFormData(prev => ({
                ...prev,
                occ_app_3: value.toUpperCase(),
                occ_app_1: '0',   // personne physique
                // on vide les champs personne morale
                occ_app_4: '',
                occ_app_5: '',
                occ_app_5_2: '',
            }));
            setSellerType('physique');
            return;
        }

        // Remplissage automatique SIREN vendeur
        if (name === 'occ_app_5') {
            const numericValue = value.replace(/[^0-9]/g, '');
            setFormData(prev => ({
                ...prev,
                occ_app_5: numericValue,
                occ_app_5_2: numericValue.slice(0, 9),
                occ_app_1: '1',     // on reste en morale
                occ_app_2: null,    // par sécurité on vide le reste du mode physique
                occ_app_3: '',
            }));
            setSellerType('morale');
            return;
        }

        // --- NOUVEAU PROPRIÉTAIRE (TITULAIRE) ---

        // Saisie "personne morale" -> on force occ_tit_1 = 1 ET on nettoie les champs "physique"
        if (['occ_tit_9', 'occ_tit_10', 'occ_tit_11'].includes(name)) {
            const cleaned =
                ['occ_tit_10', 'occ_tit_11'].includes(name)
                    ? value.replace(/[^0-9]/g, '')
                    : value.toUpperCase();

            setFormData(prev => ({
                ...prev,
                [name]: cleaned,
                occ_tit_1: '1',   // personne morale
                // on vide les champs personne physique
                occ_tit_2: null,
                occ_tit_3: '',
                occ_tit_4: '',
                occ_tit_5_1: '',
                occ_tit_5_2: '',
                occ_tit_5_3: '',
                occ_tit_6: '',
                occ_tit_7: '',
                occ_tit_8: '',
            }));
            setBuyerType('morale');
            return;
        }

        // Saisie "personne physique" -> on force occ_tit_1 = 0 ET on nettoie les champs "morale"
        if (['occ_tit_3', 'occ_tit_4', 'occ_tit_5_1', 'occ_tit_5_2', 'occ_tit_5_3', 'occ_tit_6', 'occ_tit_7', 'occ_tit_8'].includes(name)) {
            const next =
                ['occ_tit_7'].includes(name)
                    ? value.replace(/[^0-9]/g, '')
                    : value.toUpperCase();

            setFormData(prev => ({
                ...prev,
                [name]: next,
                occ_tit_1: prev.occ_tit_1 ?? '0', // on force "physique" si pas défini
                // on vide les champs personne morale
                occ_tit_9: '',
                occ_tit_10: '',
                occ_tit_11: '',
            }));
            if (buyerType === null) setBuyerType('physique');
            return;
        }

        // Remplissage automatique SIREN titulaire
        if (name === 'occ_tit_10') {
            const numericValue = value.replace(/[^0-9]/g, '');
            setFormData(prev => ({
                ...prev,
                occ_tit_10: numericValue,
                occ_tit_11: numericValue.slice(0, 9),
                occ_tit_1: '1',   // morale
                // on vide les champs physique
                occ_tit_2: null,
                occ_tit_3: '',
                occ_tit_4: '',
                occ_tit_5_1: '',
                occ_tit_5_2: '',
                occ_tit_5_3: '',
                occ_tit_6: '',
                occ_tit_7: '',
                occ_tit_8: '',
            }));
            setBuyerType('morale');
            return;
        }

        // --- CO-TITULAIRE : même logique (optionnel mais propre) ---
        if (name === 'occ_cotit_5' || name === 'occ_cotit_6') {
            // saisie morale co-titulaire
            const cleaned = name === 'occ_cotit_6'
                ? value.replace(/[^0-9]/g, '')
                : value.toUpperCase();
            setFormData(prev => ({
                ...prev,
                [name]: cleaned,
                occ_cotit_2: '1',   // morale
                // on vide la partie "physique"
                occ_cotit_3: '',
                occ_cotit_4: '',
            }));
            return;
        }
        if (name === 'occ_cotit_3' || name === 'occ_cotit_4') {
            // saisie physique co-titulaire
            setFormData(prev => ({
                ...prev,
                [name]: value.toUpperCase(),
                occ_cotit_2: prev.occ_cotit_2 ?? '0',
                // on vide la partie morale
                occ_cotit_5: '',
                occ_cotit_6: '',
            }));
            return;
        }

        // If co-titulaire count is emptied, store null
        if (name === 'occ_cotit_1' && value === '') {
            setFormData((prev) => ({
                ...prev,
                [name]: null,
            }));
            return;
        }

        const numericOnlyFields = [
            'occ_app_5', 'occ_app_5_2', 'occ_app_6', 'occ_app_10',
            'occ_tit_7', 'occ_tit_10', 'occ_tit_11', 'occ_tit_14',
            'occ_tit_19', 'occ_tit_21', 'occ_cotit_1', 'occ_cotit_6'
        ];
        const caseSensitiveFields = ['occ_tit_9', 'occ_tit_22']; // email

        if (numericOnlyFields.includes(name)) {
            const numericValue = value.replace(/[^0-9]/g, '');
            setFormData((prev) => ({
                ...prev,
                [name]: numericValue,
            }));
            return;
        }

        if (caseSensitiveFields.includes(name)) {
            setFormData((prev) => ({
                ...prev,
                [name]: value,
            }));
            return;
        }

        setFormData((prev) => ({
            ...prev,
            [name]: value.toUpperCase(),
        }));
    };

    const handleRadioChange = (name, value) => {
        setFormData(prev => {
            const updated = { ...prev, [name]: value };

            if (name === 'occ_app_1') {
                // changement de type vendeur
                if (value === '0') {
                    // on passe en personne physique -> on vide les champs morale
                    updated.occ_app_4 = '';
                    updated.occ_app_5 = '';
                    updated.occ_app_5_2 = '';
                } else if (value === '1') {
                    // on passe en personne morale -> on vide les champs physique
                    updated.occ_app_2 = null;
                    updated.occ_app_3 = '';
                }
            }

            if (name === 'occ_tit_1') {
                // changement de type titulaire
                if (value === '0') {
                    // physique -> on vide morale
                    updated.occ_tit_9  = '';
                    updated.occ_tit_10 = '';
                    updated.occ_tit_11 = '';
                } else if (value === '1') {
                    // morale -> on vide physique
                    updated.occ_tit_2   = null;
                    updated.occ_tit_3   = '';
                    updated.occ_tit_4   = '';
                    updated.occ_tit_5_1 = '';
                    updated.occ_tit_5_2 = '';
                    updated.occ_tit_5_3 = '';
                    updated.occ_tit_6   = '';
                    updated.occ_tit_7   = '';
                    updated.occ_tit_8   = '';
                }
            }

            if (name === 'occ_cotit_2') {
                // changement de type co-titulaire
                if (value === '0') {
                    // physique -> vider morale
                    updated.occ_cotit_5 = '';
                    updated.occ_cotit_6 = '';
                } else if (value === '1') {
                    // morale -> vider physique
                    updated.occ_cotit_3 = '';
                    updated.occ_cotit_4 = '';
                }
            }

            return updated;
        });

        if (name === 'occ_app_1') {
            setSellerType(value === '0' ? 'physique' : value === '1' ? 'morale' : null);
        } else if (name === 'occ_tit_1') {
            setBuyerType(value === '0' ? 'physique' : value === '1' ? 'morale' : null);
        }
    };

    const handleCheckboxChange = (name) => {
        setFormData({
            ...formData,
            [name]: formData[name] === '1' ? '0' : '1'
        });
    };

    const handleDateFieldChange = (e, fieldPrefix, part) => {
        const { value } = e.target;
        let newValue = value.replace(/[^0-9]/g, '');
        
        if (part === '1') { // Day
            // Only allow 01-31
            if (newValue.length > 2) newValue = newValue.slice(0, 2);
            if (newValue && parseInt(newValue) > 31) newValue = '31';
            if (newValue && parseInt(newValue) < 1 && newValue.length === 2) newValue = '01';
            // Only add leading zero when field loses focus or has 2 digits
            if (newValue.length === 1 && e.type === 'blur') {
                newValue = '0' + newValue;
            }
        } else if (part === '2') { // Month
            // Only allow 01-12
            if (newValue.length > 2) newValue = newValue.slice(0, 2);
            if (newValue && parseInt(newValue) > 12) newValue = '12';
            if (newValue && parseInt(newValue) < 1 && newValue.length === 2) newValue = '01';
            // Only add leading zero when field loses focus or has 2 digits
            if (newValue.length === 1 && e.type === 'blur') {
                newValue = '0' + newValue;
            }
        } else if (part === '3') { // Year
            // Only allow 4 digit years
            newValue = newValue.slice(0, 4);
            // Ensure year is not in the future
            const currentYear = new Date().getFullYear();
            if (newValue && parseInt(newValue) > currentYear && newValue.length === 4) 
                newValue = currentYear.toString();
        }
        
        setFormData({
            ...formData,
            [`${fieldPrefix}_${part}`]: newValue
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        sendData(formData);
        if (onNext) onNext();
    };

    const handlePrevious = () => {
        sendData(formData);
        if (onPrevious) onPrevious();
    };

    // Appel à l'API Sirene INSEE
    const [modalData, setModalData] = useState(null);
    const [modalError, setModalError] = useState(null);
    const [lastCheckedField, setLastCheckedField] = useState(null);

    const handleSireneLookup = async (siretOrSiren, sourceField = null) => {
    const cleaned = (siretOrSiren || "").replace(/\D/g, "");

    if (cleaned.length !== 9 && cleaned.length !== 14) {
        setModalError("Le numéro SIREN (9) ou SIRET (14) est invalide.");
        setModalData(null);
        return;
    }

    try {
        const response = await api.get(`/insee/verify/${cleaned}`);
        const etab = response.data.etablissement;
        const adr = etab?.adresseEtablissement || {};
        const ul = etab?.uniteLegale || {};

        setModalData(response.data);
        setModalError(null);
        setLastCheckedField(sourceField);

        setFormData((prev) => {
            const updates = {};

            if (sourceField === 'occ_app') {
                updates.occ_app_4 = ul?.denominationUniteLegale || prev.occ_app_4;
                updates.occ_app_6 = adr?.numeroVoieEtablissement || prev.occ_app_6;
                updates.occ_app_8 = adr?.typeVoieEtablissement || prev.occ_app_8;
                updates.occ_app_9 = adr?.libelleVoieEtablissement || prev.occ_app_9;
                updates.occ_app_10 = adr?.codePostalEtablissement || prev.occ_app_10;
                updates.occ_app_11 = adr?.libelleCommuneEtablissement || prev.occ_app_11;
            }

            if (sourceField === 'occ_tit') {
                updates.occ_tit_9 = ul?.denominationUniteLegale || prev.occ_tit_9;
                updates.occ_tit_14 = adr?.numeroVoieEtablissement || prev.occ_tit_14;
                updates.occ_tit_16 = adr?.typeVoieEtablissement || prev.occ_tit_16;
                updates.occ_tit_17 = adr?.libelleVoieEtablissement || prev.occ_tit_17;
                updates.occ_tit_19 = adr?.codePostalEtablissement || prev.occ_tit_19;
                updates.occ_tit_20 = adr?.libelleCommuneEtablissement || prev.occ_tit_20;
            }

            if (sourceField === 'occ_cotit') {
                updates.occ_cotit_5 = ul?.denominationUniteLegale || prev.occ_cotit_5;
                updates.occ_cotit_7 = adr?.numeroVoieEtablissement || prev.occ_cotit_7;
                updates.occ_cotit_9 = adr?.typeVoieEtablissement || prev.occ_cotit_9;
                updates.occ_cotit_10 = adr?.libelleVoieEtablissement || prev.occ_cotit_10;
                updates.occ_cotit_11 = adr?.codePostalEtablissement || prev.occ_cotit_11;
                updates.occ_cotit_12 = adr?.libelleCommuneEtablissement || prev.occ_cotit_12;
            }

            return {
                ...prev,
                ...updates
            };
        });
    } catch (err) {
        setModalError(err.response?.data?.message || err.message || "Erreur inconnue");
        setModalData(null);
    }
    };

    if (!isActive) return null;

    return (
        <>
            <div className="section">
                <h3>VENDEUR - ANCIEN PROPRIETAIRE - CONCESSION (en cas de cession)</h3>
                <div className="radio-group">
                    <label>VOUS ÊTES:</label>
                    <div className='radio-group-child'>
                        <div>
                            <input
                                type="radio"
                                id="occ_app_1_physique"
                                name="occ_app_1"
                                value="0"
                                checked={formData.occ_app_1 === '0'}
                                onChange={() => handleRadioChange('occ_app_1', '0')}
                                required
                            />
                            <label htmlFor="occ_app_1_physique">PERSONNE PHYSIQUE</label>
                        </div>
                        <div>
                            <input
                                type="radio"
                                id="occ_app_1_morale"
                                name="occ_app_1"
                                value="1"
                                checked={formData.occ_app_1 === '1'}
                                onChange={() => handleRadioChange('occ_app_1', '1')}
                            />
                            <label htmlFor="occ_app_1_morale">PERSONNE MORALE</label>
                        </div>
                    </div>
                </div>

                {sellerType && (
                    <>
                        {sellerType === 'physique' && (
                            <>
                                <div className="radio-group">
                                    <label>SEXE:</label>
                                    <div className='radio-group-child'>
                                        <div>
                                            <input
                                                type="radio"
                                                id="occ_app_2_homme"
                                                name="occ_app_2"
                                                value="0"
                                                checked={formData.occ_app_2 === '0'}
                                                onChange={() => handleRadioChange('occ_app_2', '0')}
                                                required
                                            />
                                            <label htmlFor="occ_app_2_homme">MASCULIN</label>
                                        </div>
                                        <div>
                                            <input
                                                type="radio"
                                                id="occ_app_2_femme"
                                                name="occ_app_2"
                                                value="1"
                                                checked={formData.occ_app_2 === '1'}
                                                onChange={() => handleRadioChange('occ_app_2', '1')}
                                            />
                                            <label htmlFor="occ_app_2_femme">FÉMININ</label>
                                        </div>
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label htmlFor="occ_app_3">NOM ET PRÉNOM:</label>
                                    <input
                                        type="text"
                                        id="occ_app_3"
                                        name="occ_app_3"
                                        value={formData.occ_app_3 || ''}
                                        onChange={handleInputChange}
                                        required
                                        pattern="^[A-Za-zÀ-ÖØ-öø-ÿ\s\-']+$"
                                        title="Veuillez entrer un nom et prénom valides (lettres, espaces, tirets et apostrophes uniquement)"
                                        maxLength="100"
                                    />
                                </div>
                            </>
                        )}

                        {sellerType === 'morale' && (
                            <>
                                <div className="form-group">
                                    <label htmlFor="occ_app_4">RAISON SOCIALE:</label>
                                    <input
                                        type="text"
                                        id="occ_app_4"
                                        name="occ_app_4"
                                        value={formData.occ_app_4 || ''}
                                        onChange={handleInputChange}
                                        required
                                        maxLength="100"
                                    />
                                </div>
                                <div className="form-group siret-group">
                                    <div className='input-group'>
                                        <label htmlFor="occ_app_5">N° SIRET:</label>
                                        <input
                                            type="text"
                                            id="occ_app_5"
                                            name="occ_app_5"
                                            value={formData.occ_app_5 || ''}
                                            onChange={handleInputChange}
                                            required
                                            pattern="^\d{14}$"
                                            title="Le numéro SIRET doit contenir exactement 14 chiffres"
                                            maxLength="14"
                                        />
                                    </div>
                                    <button
                                        type='button'
                                        onClick={() => handleSireneLookup(formData.occ_app_5, 'occ_app')}
                                        className='save-button'
                                        title="Vérifier via l'API Sirene"
                                    >
                                        Vérifier le SIRET
                                    </button>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="occ_app_5_2">N° SIREN:</label>
                                    <input
                                        type="text"
                                        id="occ_app_5_2"
                                        name="occ_app_5_2"
                                        value={formData.occ_app_5_2 || ''}
                                        onChange={handleInputChange}
                                        required
                                        pattern="^\d{9}$"
                                        title="Le numéro SIREN doit contenir exactement 9 chiffres"
                                        maxLength="9"
                                    />
                                </div>
                            </>
                        )}

                        <div className="form-group">
                            <label htmlFor="occ_app_6">N° DE LA VOIE:</label>
                            <input
                                type="text"
                                id="occ_app_6"
                                name="occ_app_6"
                                value={formData.occ_app_6 || ''}
                                onChange={handleInputChange}
                                pattern="^\d{1,4}$"
                                title="Veuillez entrer un numéro de voie valide (1 à 4 chiffres)"
                                maxLength="4"
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="occ_app_7">COMPLÉMENT (BIS, TER,..):</label>
                            <input
                                type="text"
                                id="occ_app_7"
                                name="occ_app_7"
                                value={formData.occ_app_7 || ''}
                                onChange={handleInputChange}
                                maxLength="10"
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="occ_app_8">TYPE DE VOIE (RUE, AVENUE..):</label>
                            <input
                                type="text"
                                id="occ_app_8"
                                name="occ_app_8"
                                value={formData.occ_app_8 || ''}
                                onChange={handleInputChange}
                                required
                                maxLength="20"
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="occ_app_9">NOM DE LA VOIE:</label>
                            <input
                                type="text"
                                id="occ_app_9"
                                name="occ_app_9"
                                value={formData.occ_app_9 || ''}
                                onChange={handleInputChange}
                                required
                                maxLength="100"
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="occ_app_10">CODE POSTAL:</label>
                            <input
                                type="text"
                                id="occ_app_10"
                                name="occ_app_10"
                                value={formData.occ_app_10 || ''}
                                onChange={handleInputChange}
                                required
                                pattern="^\d{5}$"
                                title="Le code postal doit contenir exactement 5 chiffres"
                                maxLength="5"
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="occ_app_11">COMMUNE:</label>
                            <input
                                type="text"
                                id="occ_app_11"
                                name="occ_app_11"
                                value={formData.occ_app_11 || ''}
                                onChange={handleInputChange}
                                required
                                pattern="^[A-Za-zÀ-ÖØ-öø-ÿ\s\-']+$"
                                title="Veuillez entrer un nom de commune valide (lettres, espaces, tirets et apostrophes uniquement)"
                                maxLength="50"
                            />
                        </div>

                        <div className="radio-group">
                            <label>JE CERTIFIE:</label>
                            <div className='radio-group-child'>
                                <div>
                                    <input
                                        type="radio"
                                        id="occ_app_12_ceder"
                                        name="occ_app_12"
                                        value="0"
                                        checked={formData.occ_app_12 === '0'}
                                        onChange={() => handleRadioChange('occ_app_12', '0')}
                                        required
                                    />
                                    <label htmlFor="occ_app_12_ceder">CÉDER</label>
                                </div>
                                <div>
                                    <input
                                        type="radio"
                                        id="occ_app_12_destruction"
                                        name="occ_app_12"
                                        value="1"
                                        checked={formData.occ_app_12 === '1'}
                                        onChange={() => handleRadioChange('occ_app_12', '1')}
                                    />
                                    <label htmlFor="occ_app_12_destruction">CÉDER POUR DESTRUCTION</label>
                                </div>
                            </div>
                        </div>

                        <div className="form-group">
                            <label>LE:</label>
                            <div className="date-input-group">
                                <div className="date-field">
                                    <label htmlFor="occ_app_13_1">JOUR</label>
                                    <input
                                        type="text"
                                        id="occ_app_13_1"
                                        name="occ_app_13_1"
                                        value={formData.occ_app_13_1 || ''}
                                        onChange={(e) => handleDateFieldChange(e, 'occ_app_13', '1')}
                                        onBlur={(e) => handleDateFieldChange(e, 'occ_app_13', '1')}
                                        placeholder="JJ"
                                        maxLength="2"
                                        required
                                    />
                                </div>
                                <div className="date-field">
                                    <label htmlFor="occ_app_13_2">MOIS</label>
                                    <input
                                        type="text"
                                        id="occ_app_13_2"
                                        name="occ_app_13_2"
                                        value={formData.occ_app_13_2 || ''}
                                        onChange={(e) => handleDateFieldChange(e, 'occ_app_13', '2')}
                                        onBlur={(e) => handleDateFieldChange(e, 'occ_app_13', '2')}
                                        placeholder="MM"
                                        maxLength="2"
                                        required
                                    />
                                </div>
                                <div className="date-field">
                                    <label htmlFor="occ_app_13_3">ANNÉE</label>
                                    <input
                                        type="text"
                                        id="occ_app_13_3"
                                        name="occ_app_13_3"
                                        value={formData.occ_app_13_3 || ''}
                                        onChange={(e) => handleDateFieldChange(e, 'occ_app_13', '3')}
                                        onBlur={(e) => handleDateFieldChange(e, 'occ_app_13', '3')}
                                        placeholder="AAAA"
                                        maxLength="4"
                                        required
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="form-group">
                            <label htmlFor="occ_app_14_time">
                                A:
                                <span className="tooltip-icon" title="Heure de la vente">?</span>
                            </label>
                            <input
                                type="time"
                                id="occ_app_14_time"
                                name="occ_app_14_time"
                                value={formData.occ_app_14_1 && formData.occ_app_14_2 ? `${formData.occ_app_14_1.padStart(2, '0')}:${formData.occ_app_14_2.padStart(2, '0')}` : ''}
                                onChange={(e) => {
                                    const timeValue = e.target.value;
                                    if (timeValue) {
                                        const [hours, minutes] = timeValue.split(':');
                                        setFormData({
                                            ...formData,
                                            occ_app_14_1: hours,
                                            occ_app_14_2: minutes
                                        });
                                    } else {
                                        setFormData({
                                            ...formData,
                                            occ_app_14_1: null,
                                            occ_app_14_2: null
                                        });
                                    }
                                }}
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label>JE CERTIFIE EN OUTRE (VEUILLEZ COCHER LA OU LES CASE.S CORRESPONDANTE.S):</label>
                            <div>
                                <input
                                    type="checkbox"
                                    id="occ_app_15"
                                    name="occ_app_15"
                                    checked={formData.occ_app_15 === '1'}
                                    onChange={() => handleCheckboxChange('occ_app_15')}
                                />
                                <label htmlFor="occ_app_15">
                                    AVOIR REMIS AU NOUVEAU PROPRIÉTAIRE UN CERTIFICAT ÉTABLI DEPUIS MOINS DE QUINZE JOURS PAR LE MINISTRE DE L&apos;INTÉRIEUR, ATTESTANT À SA DATE D&apos;ÉDITION DE LA SITUATION ADMINISTRATIVE DU VÉHICULE
                                </label>
                            </div>
                            <div>
                                <input
                                    type="checkbox"
                                    id="occ_app_16"
                                    name="occ_app_16"
                                    checked={formData.occ_app_16 === '1'}
                                    onChange={() => handleCheckboxChange('occ_app_16')}
                                />
                                <label htmlFor="occ_app_16">
                                    QUE CE VÉHICULE N&apos;A PAS SUBI DE TRANSFORMATION NOTABLE SUSCEPTIBLE DE MODIFIER LES INDICATIONS DU CERTIFICAT DE CONFORMITÉ OU DE L&apos;ACTUEL CERTIFICAT D&apos;IMMATRICULATION
                                </label>
                            </div>
                            <div>
                                <input
                                    type="checkbox"
                                    id="occ_app_17"
                                    name="occ_app_17"
                                    checked={formData.occ_app_17 === '1'}
                                    onChange={() => handleCheckboxChange('occ_app_17')}
                                />
                                <label htmlFor="occ_app_17">
                                    QUE CE VÉHICULE EST CÉDÉ POUR DESTRUCTION À UN PROFESSIONNEL DE LA DESTRUCTION DES VÉHICULES HORS D&apos;USAGE (VHU)
                                </label>
                            </div>
                        </div>
                    </>
                )}
            </div>

            <div className="section">
                <h3>TITULAIRE - NOUVEAU PROPRIETAIRE</h3>
                <div className="radio-group">
                    <label>VOUS ÊTES:</label>
                    <div className='radio-group-child'>
                        <div>
                            <input
                                type="radio"
                                id="occ_tit_1_physique"
                                name="occ_tit_1"
                                value="0"
                                checked={formData.occ_tit_1 === '0'}
                                onChange={() => handleRadioChange('occ_tit_1', '0')}
                                required
                            />
                            <label htmlFor="occ_tit_1_physique">PERSONNE PHYSIQUE</label>
                        </div>
                        <div>
                            <input
                                type="radio"
                                id="occ_tit_1_morale"
                                name="occ_tit_1"
                                value="1"
                                checked={formData.occ_tit_1 === '1'}
                                onChange={() => handleRadioChange('occ_tit_1', '1')}
                            />
                            <label htmlFor="occ_tit_1_morale">PERSONNE MORALE</label>
                        </div>
                    </div>
                </div>

                {/* Only show buyer details after selecting a type */}
                {buyerType && (
                    <>
                        {buyerType === 'physique' && (
                            <>
                                <div className="radio-group">
                                    <label>SEXE:</label>
                                    <div className='radio-group-child'>
                                        <div>
                                            <input
                                                type="radio"
                                                id="occ_tit_2_masculin"
                                                name="occ_tit_2"
                                                value="0"
                                                checked={formData.occ_tit_2 === '0'}
                                                onChange={() => handleRadioChange('occ_tit_2', '0')}
                                            />
                                            <label htmlFor="occ_tit_2_masculin">MASCULIN</label>
                                        </div>
                                        <div>
                                            <input
                                                type="radio"
                                                id="occ_tit_2_feminin"
                                                name="occ_tit_2"
                                                value="1"
                                                checked={formData.occ_tit_2 === '1'}
                                                onChange={() => handleRadioChange('occ_tit_2', '1')}
                                            />
                                            <label htmlFor="occ_tit_2_feminin">FÉMININ</label>
                                        </div>
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label htmlFor="occ_tit_3">NOM ET PRÉNOM:</label>
                                    <input
                                        type="text"
                                        id="occ_tit_3"
                                        name="occ_tit_3"
                                        value={formData.occ_tit_3 || ''}
                                        onChange={handleInputChange}
                                        required
                                        pattern="^[A-Za-zÀ-ÖØ-öø-ÿ\s\-']+$"
                                        title="Veuillez entrer un nom et prénom valides (lettres, espaces, tirets et apostrophes uniquement)"
                                        maxLength="100"
                                    />
                                </div>

                                <div className="form-group">
                                    <label htmlFor="occ_tit_4">NOM D&apos;USAGE (FACULTATIF):</label>
                                    <input
                                        type="text"
                                        id="occ_tit_4"
                                        name="occ_tit_4"
                                        value={formData.occ_tit_4 || ''}
                                        onChange={handleInputChange}
                                        pattern="^[A-Za-zÀ-ÖØ-öø-ÿ\s\-']+$"
                                        title="Veuillez entrer un nom valide (lettres, espaces, tirets et apostrophes uniquement)"
                                        maxLength="100"
                                    />
                                </div>

                                <div className="form-group">
                                    <label>NÉ.E LE:</label>
                                    <div className="date-input-group">
                                        <div className="date-field">
                                            <label htmlFor="occ_tit_5_1">JOUR</label>
                                            <input
                                                type="text"
                                                id="occ_tit_5_1"
                                                name="occ_tit_5_1"
                                                value={formData.occ_tit_5_1 || ''}
                                                onChange={(e) => handleDateFieldChange(e, 'occ_tit_5', '1')}
                                                onBlur={(e) => handleDateFieldChange(e, 'occ_tit_5', '1')}
                                                placeholder="JJ"
                                                maxLength="2"
                                                required
                                            />
                                        </div>
                                        <div className="date-field">
                                            <label htmlFor="occ_tit_5_2">MOIS</label>
                                            <input
                                                type="text"
                                                id="occ_tit_5_2"
                                                name="occ_tit_5_2"
                                                value={formData.occ_tit_5_2 || ''}
                                                onChange={(e) => handleDateFieldChange(e, 'occ_tit_5', '2')}
                                                onBlur={(e) => handleDateFieldChange(e, 'occ_tit_5', '2')}
                                                placeholder="MM"
                                                maxLength="2"
                                                required
                                            />
                                        </div>
                                        <div className="date-field">
                                            <label htmlFor="occ_tit_5_3">ANNÉE</label>
                                            <input
                                                type="text"
                                                id="occ_tit_5_3"
                                                name="occ_tit_5_3"
                                                value={formData.occ_tit_5_3 || ''}
                                                onChange={(e) => handleDateFieldChange(e, 'occ_tit_5', '3')}
                                                onBlur={(e) => handleDateFieldChange(e, 'occ_tit_5', '3')}
                                                placeholder="AAAA"
                                                maxLength="4"
                                                required
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label htmlFor="occ_tit_6">COMMUNE DE NAISSANCE:</label>
                                    <input
                                        type="text"
                                        id="occ_tit_6"
                                        name="occ_tit_6"
                                        value={formData.occ_tit_6 || ''}
                                        onChange={handleInputChange}
                                        required
                                        pattern="^[A-Za-zÀ-ÖØ-öø-ÿ\s\-']+$"
                                        title="Veuillez entrer un nom de commune valide (lettres, espaces, tirets et apostrophes uniquement)"
                                        maxLength="50"
                                    />
                                </div>

                                <div className="form-group">
                                    <label htmlFor="occ_tit_7">
                                        DÉPARTEMENT DE NAISSANCE:
                                        <span className="tooltip-icon" title="Merci d'indiquer le code de votre département à 3 chiffres, ex: 75015 => 075">?</span>
                                    </label>
                                    <input
                                        type="text"
                                        id="occ_tit_7"
                                        name="occ_tit_7"
                                        value={formData.occ_tit_7 || ''}
                                        onChange={handleInputChange}
                                        pattern="[0-9]{3}"
                                        title="Merci d'indiquer le code de votre département à 3 chiffres, ex: 75015 => 075"
                                        maxLength={3}
                                        required
                                    />
                                </div>

                                <div className="form-group">
                                    <label htmlFor="occ_tit_8">PAYS DE NAISSANCE:</label>
                                    <input
                                        type="text"
                                        id="occ_tit_8"
                                        name="occ_tit_8"
                                        value={formData.occ_tit_8 || ''}
                                        onChange={handleInputChange}
                                        required
                                        pattern="^[A-Za-zÀ-ÖØ-öø-ÿ\s\-']+$"
                                        title="Veuillez entrer un nom de pays valide (lettres, espaces, tirets et apostrophes uniquement)"
                                        maxLength="50"
                                    />
                                </div>
                            </>
                        )}

                        {buyerType === 'morale' && (
                            <>
                                <div className="form-group">
                                    <label htmlFor="occ_tit_9">RAISON SOCIALE:</label>
                                    <input
                                        type="text"
                                        id="occ_tit_9"
                                        name="occ_tit_9"
                                        value={formData.occ_tit_9 || ''}
                                        onChange={handleInputChange}
                                        required
                                        maxLength="100"
                                    />
                                </div>

                                <div className="form-group siret-group">
                                    <div className="input-group">
                                        <label htmlFor="occ_tit_10">N° SIRET:</label>
                                        <input
                                            type="text"
                                            id="occ_tit_10"
                                            name="occ_tit_10"
                                            value={formData.occ_tit_10 || ''}
                                            onChange={handleInputChange}
                                            required
                                            pattern="^\d{14}$"
                                            title="Le numéro SIRET doit contenir exactement 14 chiffres"
                                            maxLength="14"
                                        />
                                    </div>
                                    <button
                                        type='button'
                                        onClick={() => handleSireneLookup(formData.occ_tit_10, 'occ_tit')}
                                        className='save-button'
                                        title="Vérifier via l'API Sirene"
                                    >
                                        Vérifier le SIRET
                                    </button>
                                </div>

                                <div className="form-group">
                                    <label htmlFor="occ_tit_11">N° SIREN:</label>
                                    <input
                                        type="text"
                                        id="occ_tit_11"
                                        name="occ_tit_11"
                                        value={formData.occ_tit_11 || ''}
                                        onChange={handleInputChange}
                                        required
                                        pattern="^\d{9}$"
                                        title="Le numéro SIREN doit contenir exactement 9 chiffres"
                                        maxLength="9"
                                    />
                                </div>
                            </>
                        )}

                        <div className="form-group">
                            <label htmlFor="occ_tit_12">ETAGE / ESCALIER / APPARTEMENT:</label>
                            <input
                                type="text"
                                id="occ_tit_12"
                                name="occ_tit_12"
                                value={formData.occ_tit_12 || ''}
                                onChange={handleInputChange}
                                maxLength="20"
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="occ_tit_13">IMMEUBLE / RÉSIDENCE / BÂTIMENT:</label>
                            <input
                                type="text"
                                id="occ_tit_13"
                                name="occ_tit_13"
                                value={formData.occ_tit_13 || ''}
                                onChange={handleInputChange}
                                maxLength="50"
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="occ_tit_14">N° DE LA VOIE:</label>
                            <input
                                type="text"
                                id="occ_tit_14"
                                name="occ_tit_14"
                                value={formData.occ_tit_14 || ''}
                                onChange={handleInputChange}
                                pattern="^\d{1,4}$"
                                title="Veuillez entrer un numéro de voie valide (1 à 4 chiffres)"
                                maxLength="4"
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="occ_tit_15">EXTENSION (BIS, TER, ..):</label>
                            <input
                                type="text"
                                id="occ_tit_15"
                                name="occ_tit_15"
                                value={formData.occ_tit_15 || ''}
                                onChange={handleInputChange}
                                maxLength="10"
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="occ_tit_16">TYPE DE VOIE (RUE, AVENUE, ..):</label>
                            <input
                                type="text"
                                id="occ_tit_16"
                                name="occ_tit_16"
                                value={formData.occ_tit_16 || ''}
                                onChange={handleInputChange}
                                required
                                maxLength="20"
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="occ_tit_17">LIBELLÉ DE VOIE:</label>
                            <input
                                type="text"
                                id="occ_tit_17"
                                name="occ_tit_17"
                                value={formData.occ_tit_17 || ''}
                                onChange={handleInputChange}
                                required
                                maxLength="100"
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="occ_tit_18">LIEU-DIT / BP / LOCALITÉ:</label>
                            <input
                                type="text"
                                id="occ_tit_18"
                                name="occ_tit_18"
                                value={formData.occ_tit_18 || ''}
                                onChange={handleInputChange}
                                maxLength="50"
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="occ_tit_19">CODE POSTAL:</label>
                            <input
                                type="text"
                                id="occ_tit_19"
                                name="occ_tit_19"
                                value={formData.occ_tit_19 || ''}
                                onChange={handleInputChange}
                                required
                                pattern="^\d{5}$"
                                title="Le code postal doit contenir exactement 5 chiffres"
                                maxLength="5"
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="occ_tit_20">COMMUNE:</label>
                            <input
                                type="text"
                                id="occ_tit_20"
                                name="occ_tit_20"
                                value={formData.occ_tit_20 || ''}
                                onChange={handleInputChange}
                                required
                                pattern="^[A-Za-zÀ-ÖØ-öø-ÿ\s\-']+$"
                                title="Veuillez entrer un nom de commune valide (lettres, espaces, tirets et apostrophes uniquement)"
                                maxLength="50"
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="occ_tit_21">TÉLÉPHONE PORTABLE:</label>
                            <input
                                type="tel"
                                id="occ_tit_21"
                                name="occ_tit_21"
                                value={formData.occ_tit_21 || ''}
                                onChange={handleInputChange}
                                pattern="^(?:(?:\+|00)33|0)\s*[1-9](?:[\s.-]*\d{2}){4}$"
                                title="Veuillez entrer un numéro de téléphone français valide (ex: 06 12 34 56 78)"
                                maxLength="10"
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="occ_tit_22">ADRESSE MAIL:</label>
                            <input
                                type="email"
                                id="occ_tit_22"
                                name="occ_tit_22"
                                value={formData.occ_tit_22 || ''}
                                onChange={handleInputChange}
                                pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$"
                                title="Veuillez entrer une adresse e-mail valide"
                                maxLength="100"
                            />
                        </div>

                        <div className="form-group">
                            <label>CERTIFIE (VEUILLEZ COCHER LA OU LES CASE.S CORRESPONDANTE.S):</label>
                            <div>
                                <input
                                    type="checkbox"
                                    id="occ_tit_23"
                                    name="occ_tit_23"
                                    checked={formData.occ_tit_23 === '1'}
                                    onChange={() => handleCheckboxChange('occ_tit_23')}
                                />
                                <label htmlFor="occ_tit_23">
                                    ACQUÉRIR LE VÉHICULE DÉSIGNÉ CI-DESSUS AUX DATES ET HEURES INDIQUÉES PAR L&apos;ANCIEN PROPRIÉTAIRE
                                </label>
                            </div>
                            <div>
                                <input
                                    type="checkbox"
                                    id="occ_tit_24"
                                    name="occ_tit_24"
                                    checked={formData.occ_tit_24 === '1'}
                                    onChange={() => handleCheckboxChange('occ_tit_24')}
                                />
                                <label htmlFor="occ_tit_24">
                                    AVOIR ÉTÉ INFORMÉ DE LA SITUATION ADMINISTRATIVE DU VÉHICULE
                                </label>
                            </div>
                        </div>
                    </>
                )}
            </div>

            <div className="section">
                <h3>CO-TITULAIRE (En cas de demande d&apos;immatriculation)</h3>
                <div className="radio-group">
                    <label>LE VÉHICULE EST-IL DANS UN CAS DE MULTI-PROPRIÉTÉ?</label>
                    <div className='radio-group-child'>
                        <div>
                            <input
                                type="radio"
                                id="occ_cotit_0_oui"
                                name="occ_cotit_0"
                                value="1"
                                checked={formData.occ_cotit_0 === '1'}
                                onChange={() => handleRadioChange('occ_cotit_0', '1')}
                            />
                            <label htmlFor="occ_cotit_0_oui">OUI</label>
                        </div>
                        <div>
                            <input
                                type="radio"
                                id="occ_cotit_0_non"
                                name="occ_cotit_0"
                                value="0"
                                checked={formData.occ_cotit_0 === '0'}
                                onChange={() => handleRadioChange('occ_cotit_0', '0')}
                            />
                            <label htmlFor="occ_cotit_0_non">NON</label>
                        </div>
                    </div>
                </div>

                {formData.occ_cotit_0 === '1' && (
                    <>
                        <div className="form-group">
                            <label htmlFor="occ_cotit_1">NOMBRE DE PERSONNES TITULAIRES DU CERTIFICAT D&apos;IMMATRICULATION:</label>
                            <input
                                type="text"
                                id="occ_cotit_1"
                                name="occ_cotit_1"
                                value={formData.occ_cotit_1 || ''}
                                onChange={handleInputChange}
                                maxLength={2}
                                pattern="^[0-9]{1,2}$"
                                inputMode="numeric"
                                title="Veuillez saisir jusqu'à 2 chiffres"
                                
                            />
                        </div>

                        <div className="radio-group">
                            <label>VOUS ÊTES:</label>
                            <div className='radio-group-child'>
                                <div>
                                    <input
                                        type="radio"
                                        id="occ_cotit_2_physique"
                                        name="occ_cotit_2"
                                        value="0"
                                        checked={formData.occ_cotit_2 === '0'}
                                        onChange={() => handleRadioChange('occ_cotit_2', '0')}
                                        required
                                    />
                                    <label htmlFor="occ_cotit_2_physique">PERSONNE PHYSIQUE</label>
                                </div>
                                <div>
                                    <input
                                        type="radio"
                                        id="occ_cotit_2_morale"
                                        name="occ_cotit_2"
                                        value="1"
                                        checked={formData.occ_cotit_2 === '1'}
                                        onChange={() => handleRadioChange('occ_cotit_2', '1')}
                                    />
                                    <label htmlFor="occ_cotit_2_morale">PERSONNE MORALE</label>
                                </div>
                            </div>
                        </div>

                        {formData.occ_cotit_2 === '0' && (
                            <>
                             
                                <div className="form-group">
                                    <label htmlFor="occ_cotit_3">NOM ET PRÉNOM:</label>
                                    <input
                                        type="text"
                                        id="occ_cotit_3"
                                        name="occ_cotit_3"
                                        value={formData.occ_cotit_3 || ''}
                                        onChange={handleInputChange}
                                        pattern="[A-Za-zÀ-ÖØ-öø-ÿ\s\-']+"
                                        title="Veuillez saisir un nom et prénom valides"
                                        required
                                    />
                                </div>

                                <div className="form-group">
                                    <label htmlFor="occ_cotit_4">NOM D&apos;USAGE (FACULTATIF):</label>
                                    <input
                                        type="text"
                                        id="occ_cotit_4"
                                        name="occ_cotit_4"
                                        value={formData.occ_cotit_4 || ''}
                                        onChange={handleInputChange}
                                        pattern="[A-Za-zÀ-ÖØ-öø-ÿ\s\-']+"
                                        title="Veuillez saisir un nom d'usage valide"
                                    />
                                </div>

                                <div className="form-group">
                                    <label htmlFor="cotit_7">N° DE LA VOIE:</label>
                                    <input
                                        type="text"
                                        id="occ_cotit_7"
                                        name="occ_cotit_7"
                                        value={formData.occ_cotit_7 || ''}
                                        onChange={handleInputChange}
                                        required
                                        pattern="^\d{1,4}$"
                                        title="Veuillez entrer un numéro de voie valide (1 à 4 chiffres)"
                                        maxLength="4"
                                    />
                                </div>

                                <div className="form-group">
                                    <label htmlFor="occ_cotit_8">EXTENSION (BIS, TER, ..):</label>
                                    <input
                                        type="text"
                                        id="occ_cotit_8"
                                        name="occ_cotit_8"
                                        value={formData.occ_cotit_8 || ''}
                                        onChange={handleInputChange}
                                        maxLength={10}
                                    />
                                </div>

                                <div className="form-group">
                                    <label htmlFor="cotit_9">TYPE DE VOIE (RUE, AVENUE, ..):</label>
                                    <input
                                        type="text"
                                        id="occ_cotit_9"
                                        name="occ_cotit_9"
                                        value={formData.occ_cotit_9 || ''}
                                        onChange={handleInputChange}
                                        required
                                        maxLength={20}
                                    />
                                </div>

                                <div className="form-group">
                                    <label htmlFor="occ_cotit_10">NOM DE LA VOIE:</label>
                                    <input
                                        type="text"
                                        id="occ_cotit_10"
                                        name="occ_cotit_10"
                                        value={formData.occ_cotit_10 || ''}
                                        onChange={handleInputChange}
                                        required
                                        maxLength={100}
                                    />
                                </div>

                                <div className="form-group">
                                    <label htmlFor="occ_cotit_11">CODE POSTAL:</label>
                                    <input
                                        type="text"
                                        id="occ_cotit_11"
                                        name="occ_cotit_11"
                                        value={formData.occ_cotit_11 || ''}
                                        onChange={handleInputChange}
                                        required
                                        pattern="^\d{5}$"
                                        title="Le code postal doit contenir exactement 5 chiffres"
                                        maxLength="5"
                                    />
                                </div>

                                <div className="form-group">
                                    <label htmlFor="occ_cotit_12">COMMUNE:</label>
                                    <input
                                        type="text"
                                        id="occ_cotit_12"
                                        name="occ_cotit_12"
                                        value={formData.occ_cotit_12 || ''}
                                        onChange={handleInputChange}
                                        required
                                        pattern="^[A-Za-zÀ-ÖØ-öø-ÿ\s\-']+$"
                                        title="Veuillez entrer un nom de commune valide (lettres, espaces, tirets et apostrophes uniquement)"
                                        maxLength="50"
                                    />
                                </div>
                            </>
                        )}

                        {formData.occ_cotit_2 === '1' && (
                            <>
                                <div className="form-group">
                                    <label htmlFor="occ_cotit_5">RAISON SOCIALE:</label>
                                    <input
                                        type="text"
                                        id="occ_cotit_5"
                                        name="occ_cotit_5"
                                        value={formData.occ_cotit_5 || ''}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </div>

                                <div className="form-group siret-group">
                                    <div className='input-group'>
                                        <label htmlFor="occ_cotit_6">N° SIRET:</label>
                                        <input
                                            type="text"
                                            id="occ_cotit_6"
                                            name="occ_cotit_6"
                                            value={formData.occ_cotit_6 || ''}
                                            onChange={handleInputChange}
                                            pattern="[0-9]{14}"
                                            maxLength="14"
                                            title="Le numéro SIRET doit contenir 14 chiffres"
                                            required
                                        />
                                    </div>
                                    <button
                                        type='button'
                                        onClick={() => handleSireneLookup(formData.occ_cotit_6, 'occ_cotit')}
                                        className='save-button'
                                        title="Vérifier via l'API Sirene"
                                        >
                                        Vérifier le SIRET
                                    </button>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="cotit_7">N° DE LA VOIE:</label>
                                    <input
                                        type="text"
                                        id="occ_cotit_7"
                                        name="occ_cotit_7"
                                        value={formData.occ_cotit_7 || ''}
                                        onChange={handleInputChange}
                                        pattern="^\d{1,4}$"
                                        title="Veuillez entrer un numéro de voie valide (1 à 4 chiffres)"
                                        maxLength="4"
                                    />
                                </div>

                                <div className="form-group">
                                    <label htmlFor="occ_cotit_8">EXTENSION (BIS, TER, ..):</label>
                                    <input
                                        type="text"
                                        id="occ_cotit_8"
                                        name="occ_cotit_8"
                                        value={formData.occ_cotit_8 || ''}
                                        onChange={handleInputChange}
                                        maxLength={10}
                                    />
                                </div>

                                <div className="form-group">
                                    <label htmlFor="cotit_9">TYPE DE VOIE (RUE, AVENUE, ..):</label>
                                    <input
                                        type="text"
                                        id="occ_cotit_9"
                                        name="occ_cotit_9"
                                        value={formData.occ_cotit_9 || ''}
                                        onChange={handleInputChange}
                                        required
                                        maxLength={20}
                                    />
                                </div>

                                <div className="form-group">
                                    <label htmlFor="occ_cotit_10">NOM DE LA VOIE:</label>
                                    <input
                                        type="text"
                                        id="occ_cotit_10"
                                        name="occ_cotit_10"
                                        value={formData.occ_cotit_10 || ''}
                                        onChange={handleInputChange}
                                        required
                                        maxLength={100}
                                    />
                                </div>

                                <div className="form-group">
                                    <label htmlFor="occ_cotit_11">CODE POSTAL:</label>
                                    <input
                                        type="text"
                                        id="occ_cotit_11"
                                        name="occ_cotit_11"
                                        value={formData.occ_cotit_11 || ''}
                                        onChange={handleInputChange}
                                        required
                                        pattern="^\d{5}$"
                                        title="Le code postal doit contenir exactement 5 chiffres"
                                        maxLength="5"
                                    />
                                </div>

                                <div className="form-group">
                                    <label htmlFor="occ_cotit_12">COMMUNE:</label>
                                    <input
                                        type="text"
                                        id="occ_cotit_12"
                                        name="occ_cotit_12"
                                        value={formData.occ_cotit_12 || ''}
                                        onChange={handleInputChange}
                                        required
                                        pattern="^[A-Za-zÀ-ÖØ-öø-ÿ\s\-']+$"
                                        title="Veuillez entrer un nom de commune valide (lettres, espaces, tirets et apostrophes uniquement)"
                                        maxLength="50"
                                    />
                                </div>
                            </>
                        )}
                    </>
                )}

            </div>

            {/* Modal API Sirene */}
            {modalData && (
                <div className="modal-overlay">
                    <div className="modal-content modal-insee">
                        <h3>Informations {lastCheckedField === 'occ_app' ? "Vendeur" : "Acheteur"}</h3>
                        <p>
                            <strong>Raison sociale :</strong>{" "}
                            {modalData.etablissement?.uniteLegale?.denominationUniteLegale ||
                            "[Non renseignée]"}
                        </p>

                        <p>
                            <strong>Nom :</strong>{" "}
                            {modalData.etablissement?.uniteLegale?.nomUniteLegale || "[Non renseigné]"}
                        </p>

                        <p>
                            <strong>Prénom :</strong>{" "}
                            {modalData.etablissement?.uniteLegale?.prenom1UniteLegale || "[Non renseigné]"}
                        </p>

                        <p>
                            <strong>Adresse :</strong>{" "}
                            {[
                            modalData.etablissement?.adresseEtablissement?.numeroVoieEtablissement,
                            modalData.etablissement?.adresseEtablissement?.typeVoieEtablissement,
                            modalData.etablissement?.adresseEtablissement?.libelleVoieEtablissement
                            ]
                            .filter(Boolean)
                            .join(" ") || "[Non renseignée]"}
                        </p>

                        <p>
                            <strong>Code postal :</strong>{" "}
                            {modalData.etablissement?.adresseEtablissement?.codePostalEtablissement || "[Non renseigné]"}
                        </p>

                        <p>
                            <strong>Commune :</strong>{" "}
                            {modalData.etablissement?.adresseEtablissement?.libelleCommuneEtablissement || "[Non renseignée]"}
                        </p>
                        <button className='finish-button' onClick={() => setModalData(null)}>Fermer</button>
                    </div>
                </div>
                )}

                {modalError && (
                <div className="error-message">
                    {modalError} <button className='finish-button' onClick={() => setModalError(null)}>Fermer</button>
                </div>
            )}
            
            <div className="button-container">
                <button type="button" className="prev-button" onClick={handlePrevious}>PRÉCÉDENT</button>
                <button type="button" className="save-button" onClick={() => handleSave(formData)}>ENREGISTRER</button>
                <button type="button" className="next-button" onClick={handleSubmit}>SUIVANT</button>
            </div>
        </>
    );
};

StepTwoOccasion.propTypes = {
    sendData: PropTypes.func.isRequired,
    isActive: PropTypes.bool,
    onNext: PropTypes.func,
    onPrevious: PropTypes.func,
    commonData: PropTypes.object,
    handleSave: PropTypes.func.isRequired,
};

export default StepTwoOccasion;